import BaseModel from '../BaseModel';

export default class Statuses extends BaseModel {
  static entity = 'statuses';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      name: this.string(null).nullable(),
      sort: this.number(null).nullable(),
      status: this.string(null).nullable(),
      system: this.boolean(),
      active: this.boolean(),
    };
  }

  static apiConfig = {
    actions: {
      fetchAllStatuses() {
        return this.get('candidates/status/index');
      },
    },
  }
}
